export default __webpack_public_path__ + "static/media/14S.9c13cb2e.webp";